import { rpc } from "src/composables/Rpc";
import { DateTimelike, Guid, Int } from "src/interfaces/InleagueApiV1";

import { PracticeSlotAssignment } from "../GameScheduler/calendar/PracticeScheduler.io";
import { WithDefiniteExpanded } from "src/helpers/utils";
import { GameForGameSchedulerView } from "src/composables/InleagueApiV1.GameScheduler";
import { mungeRawMenu, TeamChooserMenu } from "src/composables/InleagueApiV1.TeamChooser2";
import { AxiosInstance } from "axios";

export interface AbsenteeCandidate {
  /**
   * source of candidacy
   */
  type: "playerLoan" | "playerAssignment"
  /**
   * ID of source of candidacy (i.e. if playerLoan, this is that loan's `loanID`, and etc.)
   */
  id: Guid,
  child: {
    childID: Guid,
    playerFirstName: string,
    playerLastName: string,
  },
  uniform: string,
  /**
   * If they have an absence already on file, this is that absence; otherwise, null
   */
  absences: Absence[]
}

export interface Absence {
  absenceID: Int,

  type: "game" | "practice" | "loose"
  game?: {
    gameID: Guid,
  }
  practice?: {
    practiceSlotAssignmentID: Int
  }
  loose?: {
    datetime: DateTimelike
  }

  comments: string,

  createdBy: {
    userID: Guid,
    firstName: string,
    lastName: string,
  },
  createdOn: DateTimelike,
}

export type Game = GameForGameSchedulerView & {__brand_attendanceTracker__: never}
export type Practice = WithDefiniteExpanded<PracticeSlotAssignment, "practiceSlot.field"> & {__brand_attendanceTracker__: never}

export interface UpdateAbsenceRequest {
  absentFrom: {
    seasonUID: Guid,
    teamID: Guid,
    type: "game" | "practice" | "loose",
    id: Guid | Int
  },
  absences: {
    whoType: "playerAssignment" | "playerLoan",
    whoID: Guid,
    absenceID: "" | Int,
    wasAbsent: boolean, // false will delete the absence
    comments: string,
    // only relevant in "loose" case, otherwise can be nullish
    datetime: DateTimelike,
  }[]
}

// TODO: 'chainable' capability on `rpc`, like rpc<A,R>(...).then(f : R -> R2) : (ax, A) => Promise<R2>
export const getMenu = async function (ax: AxiosInstance) : Promise<TeamChooserMenu> {
  const response = await ax.get("v1/attendanceTracker/getMenu");
  const raw = response.data.data
  return mungeRawMenu(raw)
}
export const listAbsenteeCandidates = rpc<{seasonUID: Guid, teamID: Guid, attendableType: "game" | "practice" | "loose", attendableID: string | number}, AbsenteeCandidate[]>("get", "v1/attendanceTracker/listAbsenteeCandidates")
export const listGames = rpc<{seasonUID: Guid, teamID: Guid}, Game[]>("get", "v1/attendanceTracker/listGames")
export const listPractices = rpc<{seasonUID: Guid, teamID: Guid}, Practice[]>("get", "v1/attendanceTracker/listPractices")
export const updateAbsences = rpc<UpdateAbsenceRequest, void>("post", "v1/attendanceTracker/updateAbsences")
